import { Injectable, TemplateRef } from '@angular/core';
import { BehaviorSubject, Observable, Subject } from 'rxjs';
import { BannerMessageVariant } from '@amobee/component-library';
import { INotificationMessage } from '../common/components/message-notification/message-notification.component';

@Injectable({
    providedIn: 'root'
})
export class MessageService {
    constructor() { }

    private notification = new Subject<INotificationMessage>();
    private formTitle = new BehaviorSubject<[string, boolean, string?]>(['', true, '']);

    sendNotification(message: string, type: BannerMessageVariant, timeout: number = 0, ignoreDuplicate: boolean = true, dismissible: boolean = true) {
        let ref = { text: message, variant: type, timeout: timeout, ignoreDuplicate, dismissible };
        this.notification.next(ref);
        return ref;
    }

    sendNotificationCustomHtml(customHtml: { scopeValue?: any; templateRef: TemplateRef<any> }, type: BannerMessageVariant, timeout: number = 0, ignoreDuplicate: boolean = true, dismissible: boolean = true) {
        let ref = { customHtml: customHtml, variant: type, timeout: timeout, ignoreDuplicate, dismissible }
        this.notification.next(ref);
        return ref;
    }

    getNotification(): Observable<INotificationMessage> {
        return this.notification.asObservable();
    }

    removeNotification(message: INotificationMessage) {
        message.isRemove = true;
        this.notification.next(message);
    }

    sendFormTitle(message: [string, boolean, string?]) {
        this.formTitle.next(message);
    }

    getFormTitle(): Observable<[string, boolean, string?]> {
        return this.formTitle.asObservable();
    }
}
